import React from 'react';
import { ButtonType, ContainedButton } from '../../../atoms/Buttons';
/**
 * Guest login Form
 * @param {*} props - Object
 */
export const DispositionModuleForm = props => {
  const { modalContent, onDispositionMethodSubmit, setRef = null } = props;
  const { contentText = '', infoObject = null, orderTypes = [] } = modalContent;
  console.log('+++++++++', orderTypes);
  const orderButtons = orderTypes.map(item => {
    return (
      <ContainedButton
        key={item.type}
        variant={item.selectDefault ? ButtonType.secondary : ButtonType.tertiary}
        className={'disposition-button'}
        onClickHandler={event => {
          onDispositionMethodSubmit(event, item.type, false, item.dispositionType);
        }}
        id='DispositionModuleFormSubmit'
        type='submit'
        data-testid={`disposition-order-click-handler-${item.type}`}
        aria-label={`order type ${item.buttonText}`}
      >
        {item.buttonText}
      </ContainedButton>
    );
  });
  return (
    <React.Fragment>
      <div ref={setRef} className='disposition-module-form' data-testid='disposition-component'>
        <h3 className='content-text' data-testid='contenttext-component'>
          {contentText}
        </h3>
        {infoObject && (
          <div role='alert' className='info-text' data-testid='info-component'>
            <span>{infoObject.infoText}</span>
          </div>
        )}
        <form className='form' onSubmit={onDispositionMethodSubmit} data-testid='form-component'>
          {orderButtons}
        </form>
      </div>
    </React.Fragment>
  );
};

export default DispositionModuleForm;
